import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


export const getChatBackupSuccess = (data) => {
  return {
    type: actionTypes.GET_CHAT_BACKUP,
    payload: {
      chat: data.Data,
    },
  };
};

export const getChatBackup = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GetChatdata`, data)
    .then((response) => {
      if (response) {
        dispatch(getChatBackupSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
